import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";
import { TextareaAutosize } from "@material-ui/core";

class Product extends React.Component {
  initialState = {
    anotacion_marginal: "",
    peticion: "",
    id: this.props.match.params["id"],
    tipo_producto_id: this.props.match.params["tipo_producto_id"],
    solicitud_id: this.props.match.params["solicitud_id"],
    nombre_comercial: "",
    grupo_ingrediente_id: "",
    clase_producto_id: "",
    categorizacion_oficial_id: "",
    uso: "", //indicaciones
    preparacion_extemporanea: "",
    precauciones_generales: "",
    precauciones_uso: "",
    precauciones_almacenamiento: "",
    caducidad_producto: "",
    medida_tiempo_id: "",
    pais_origen_id: "",
    forma_farmaceutica_id: "",
    tipo_producto_veterinario_id: "1",
    observaciones: "",
    tomo: "",
    tiempo: "",
    fabricante_id: "",
    establecimiento_id: "",
    titular_id: "",
    propiedades_inmunologicas: "",
    validez_preparacion: "",
    instrucciones_uso: "",
    clasificacion_id: "",
    //ACTIVO
    principio_activo: {
      rel_id: "",
      principio_activo_id: "",
      principio_activo_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    principios_activos: [],
    //EXCIPIENTE
    excipiente: {
      rel_id: "",
      excipiente_id: "",
      excipiente_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    excipientes: [],
    //DOSIS
    dosis_especie: {
      rel_id: "",
      dosis: "",
      especie_id: "",
      especie_name: "",
      tiene_categoria: false,
      categoria_id: "",
      categoria_name: "",
    },
    dosis: [],
    //DESCARTE
    descarte: {
      rel_id: "",
      periodo: "",
      especie_prod_id: "",
      especie_prod_name: "",
      medida_tiempo_id: "",
      medida_tiempo_name: "",
    },
    descartes: [],
    //EMPAQUE
    empaque: {
      rel_id: "",
      empaque_id: "",
      empaque_name: "",
      //presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      presentacion_unidad_medida_name: "",
    },
    empaques: [],
    //COMPOSICION BIOLOGICA
    composicion_biologica: {
      rel_id: "",
      composicion_biologica_id: "",
      composicion_biologica_name: "",
      titulo_unidad_medida: "",
    },
    composiciones_biologicas: [],
    //COMPOSICION QUIMICA
    composicion_quimica: {
      rel_id: "",
      composicion_quimica_id: "",
      composicion_quimica_name: "",
      concentracion: "",
      unidad_medida: "",
      unidad_medida_name: "",
    },
    composiciones_quimicas: [],
    //MODO EMPLEO
    modo_empleo: {
      rel_id: "",
      modo_empleo: "",
      especie_id: "",
      especie_name: "",
      tiene_categoria: false,
      categoria_id: "",
      categoria_name: "",
    },
    modos_empleo: [],
    //COMPONENTE
    componente: {
      rel_id: "",
      componente: "",
      concentracion: "",
    },
    componentes: [],
    //ESPECIE INTERES DIAGNOSTICO
    especie_interes_diagnostico: {
      rel_id: "",
      especie_id: "",
      especie_name: "",
    },
    especies_interes_diagnostico: [],
    //PRESENTACIONES
    presentacion: {
      rel_id: "",
      //presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      presentacion_unidad_medida_name: "",
    },
    presentaciones: [],
    //ANALISIS GARANTIZADO
    analisis_garantizado: {
      rel_id: "",
      analisis_id: "",
      analisis_name: "",
      porcentaje: "",
    },
    analisis: [],
    //INGREDIENTES
    ingrediente: {
      rel_id: "",
      ingrediente_id: "",
      ingrediente_name: "",
    },
    ingredientes: [],
    fabricantes: [], //establecimientos a los que pertenezco que tengan como actividad fabricante
    representantes_legales: [], //listado de los representantes de los establecimientos a los que pertenezco
    regentes: [], //listado de los regentes de los establecimientos a los que pertenezco
    titulares: [], //listado de los establecimientos titulares
    tipo: "medicamento_veterinario",
    options_ingredientes_activos: [],
    options_ingredientes_activos_prod: [],
    options_ingredientes_excipientes: [],
    options_ingredientes_excipientes_prod: [],
    options_unidad_medida: Api.loadCatalogue("cat_unidad_medida"),
    options_especies: Api.loadCatalogue("cat_especie"),
    options_categoria: [],
    options_empaque: [],
    options_empaque_tipo_1: [],
    options_empaque_tipo_2: [],
    options_empaque_tipo_3: [],
    options_forma_farmaceutica: [],
    options_forma_farmaceutica_tipo_1: [],
    options_forma_farmaceutica_tipo_2: [],
    options_forma_farmaceutica_tipo_3: [],
    options_forma_farmaceutica_tipo_5: [],
    options_especies_producto: Api.loadCatalogue("cat_especie_producto"),
    options_medida_tiempo: Api.loadCatalogue("cat_medida_tiempo"),
    //options_forma_farmaceutica: Api.loadCatalogue("cat_forma_farmaceutica"),
    options_paises: Api.loadCatalogue("countries"),
    options_composicion_biologica: Api.loadCatalogue(
      "cat_composicion_biologica"
    ),
    options_composicion_quimica: Api.loadCatalogue("cat_composicion_quimica"),
    options_clasificacion: Api.loadCatalogue("cat_clasificacion"),
    options_analisis: Api.loadCatalogue("cat_analisis"),
    options_ingredientes: [],
    control_ingredientes: [],
    producto: {
      id: "",
      nombre_comercial: "",
      grupo_ingrediente_id: "",
      clase_producto_id: "",
      categorizacion_oficial_id: "",
      uso: "",
      precauciones_generales: "",
      caducidad_producto: "",
      medida_tiempo_id: "",
      pais_id: "",
      pais_name: "",
      forma_farmaceutica_id: "",
      tipo_producto_veterinario_id: "",
      precauciones_uso: "",
      precauciones_almacenamiento: "",
      propiedades_inmunologicas: "",
      instrucciones_uso: "",
      clasificacion_id: "",
    },
    //CLASIFICACION PRODUCTO
    clasificacion: {
      grupo_ingrediente_id: "",
      clase_producto_id: "",
      categorizacion_oficial_id: "",
      tomo: "",
      folio: "",
      no_registro_drycip: "",
      dossier: "",
    },
    options_grupo_ingredientes: Api.loadCatalogue("cat_grupo_ingrediente"),
    options_categorizacion_oficial: Api.loadCatalogue(
      "cat_categorizacion_oficial"
    ),
    options_clasificacion_producto: [],
    rel_eliminados: {
      principios_activos: [],
      excipientes: [],
      dosis: [],
      empaques: [],
      descartes: [],
      composiciones_biologicas: [],
      composiciones_quimicas: [],
      componentes: [],
      especies_interes_diagnostico: [],
      modos_empleo: [],
      presentaciones: [],
      analisis: [],
      ingredientes: [],
    },
    valor_anterior: "",
    valor_nuevo: "",
  };

  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    this.state = this.initialState;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpcionesRadio = this.handleOpcionesRadio.bind(this);

    this.handlePrincipioActivo = this.handlePrincipioActivo.bind(this);
    this.addPrincipioActivo = this.addPrincipioActivo.bind(this);
    this.removePrincipioActivo = this.removePrincipioActivo.bind(this);

    this.handleExcipiente = this.handleExcipiente.bind(this);
    this.addExcipiente = this.addExcipiente.bind(this);
    this.removeExcipiente = this.removeExcipiente.bind(this);

    this.handleDosisEspecie = this.handleDosisEspecie.bind(this);
    this.addDosisEspecie = this.addDosisEspecie.bind(this);
    this.removeDosisEspecie = this.removeDosisEspecie.bind(this);

    this.handleEmpaque = this.handleEmpaque.bind(this);
    this.addEmpaque = this.addEmpaque.bind(this);
    this.removeEmpaque = this.removeEmpaque.bind(this);

    this.handleDescarte = this.handleDescarte.bind(this);
    this.addDescarte = this.addDescarte.bind(this);
    this.removeDescarte = this.removeDescarte.bind(this);

    this.handleComposicionBiologica =
      this.handleComposicionBiologica.bind(this);
    this.addComposicionBio = this.addComposicionBio.bind(this);
    this.removeComposicionBio = this.removeComposicionBio.bind(this);

    this.handleComposicionQuimica = this.handleComposicionQuimica.bind(this);
    this.addComposicionQuimica = this.addComposicionQuimica.bind(this);
    this.removeComposicionQuimica = this.removeComposicionQuimica.bind(this);

    this.handleComponente = this.handleComponente.bind(this);
    this.addComponente = this.addComponente.bind(this);
    this.removeComponente = this.removeComponente.bind(this);

    this.handleEspecieInteres = this.handleEspecieInteres.bind(this);
    this.addEspecieInteres = this.addEspecieInteres.bind(this);
    this.removeEspecieInteres = this.removeEspecieInteres.bind(this);

    this.handleModoEmpleo = this.handleModoEmpleo.bind(this);
    this.addModoEmpleo = this.addModoEmpleo.bind(this);
    this.removeModoEmpleo = this.removeModoEmpleo.bind(this);

    this.handlePresentaciones = this.handlePresentaciones.bind(this);
    this.addPresentaciones = this.addPresentaciones.bind(this);
    this.removePresentaciones = this.removePresentaciones.bind(this);

    this.handleAnalisis = this.handleAnalisis.bind(this);
    this.addAnalisis = this.addAnalisis.bind(this);
    this.removeAnalisis = this.removeAnalisis.bind(this);

    this.handleIngrediente = this.handleIngrediente.bind(this);
    this.addIngrediente = this.addIngrediente.bind(this);
    this.removeIngrediente = this.removeIngrediente.bind(this);

    this.handleReset = this.handleReset.bind(this);

    this.handleClasificacion = this.handleClasificacion.bind(this);
  }

  componentDidMount() {
    Api.loading(1);
    let tipo_producto_id = this.props.match.params["tipo_producto_id"];

    //this.AnotacionProducto.querySelector(".precauciones_generales").style.display = "none";
    Api.fetch(
      "app/getAMProducto?id=" +
        this.state.id +
        "&solicitud_id=" +
        this.state.solicitud_id
    ).then((data) => {
      if (data) {
        this.setState({
          anotacion_marginal: data.anotacion_marginal,
          peticion: data.peticion,
        });
      }
    });

    //Traemos la informacion general del producto
    //Tomamos en cuenta primero que tipo de producto veterinario es y a partir de eso llenamos los campos
    //Quitamos la opcion de poder elegir los radio buttons (default) y los campos que cambian dependiendo de la opcion
    Api.fetch("app/getProductoInfo?id=" + this.state.id).then((data) => {
      if (data) {
        let tipo;
        let opt_empaque = [];
        let opt_forma_farmaceutica = [];
        let tpv;

        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_5;

        switch (data[0].tipo_producto_veterinario_id) {
          case "1":
            tipo = "medicamento_veterinario";
            opt_empaque = this.state.options_empaque_tipo_1;
            opt_forma_farmaceutica =
              this.state.options_forma_farmaceutica_tipo_1;
            tpv = "1";
            break;
          case "2":
            tipo = "biologico";
            opt_empaque = this.state.options_empaque_tipo_2;
            opt_forma_farmaceutica =
              this.state.options_forma_farmaceutica_tipo_2;
            tpv = "2";
            break;
          case "3":
            tipo = "producto_afin";
            opt_empaque = this.state.options_empaque_tipo_3;
            opt_forma_farmaceutica =
              this.state.options_forma_farmaceutica_tipo_3;
            tpv = "3";
            break;
          case "4":
            tipo = "reactivos_diagnosticos";
            tpv = "4";
            break;
          default:
        }

        this.setState({
          tipo: tipo,
          //tipo_producto_veterinario_id: tpv,
          options_empaque: opt_empaque,
          options_forma_farmaceutica: opt_forma_farmaceutica,
        });

        let clasificacion = { ...this.clasificacion };
        clasificacion["grupo_ingrediente_id"] = data[0].grupo_ingrediente_id;
        clasificacion["clase_producto_id"] = data[0].clase_producto_id;
        clasificacion["categorizacion_oficial_id"] =
          data[0].categorizacion_oficial_id;
        clasificacion["tomo"] = data[0].tomo;
        clasificacion["folio"] = data[0].folio;
        clasificacion["no_registro_drycip"] = data[0].no_registro_drycip;
        clasificacion["dossier"] = data[0].dossier;

        if (data[0].tipo_producto_veterinario_id <= 3) {
          /*  this.clasificacion.querySelector("#clase_producto_id").innerHTML =
            "<option value=''>Cargando espere...</option>"; */
          Api.fetch(
            "app/getCatClasificacionProVet?id=" +
              data[0].tipo_producto_veterinario_id
          ).then((r) => {
            this.setState({ options_clasificacion_producto: r });
          });
        }

        this.setState({
          producto: data[0],
          tipo_producto_veterinario_id: data[0].tipo_producto_veterinario_id,
          // tipo: tipo,
          //informacion campos productos
          nombre_comercial: data[0].nombre_comercial,
          grupo_ingrediente_id: data[0].grupo_ingrediente_id,
          clase_producto_id: data[0].clase_producto_id,
          categorizacion_oficial_id: data[0].categorizacion_oficial_id,
          uso: data[0].uso, //indicaciones
          precauciones_generales: data[0].precauciones_generales,
          precauciones_uso: data[0].precauciones_uso,
          precauciones_almacenamiento: data[0].precauciones_almacenamiento,
          caducidad_producto: data[0].caducidad_producto,
          medida_tiempo_id: data[0].medida_tiempo_id,
          pais_origen_id: data[0].pais_id,
          forma_farmaceutica_id: data[0].forma_farmaceutica_id,
          observaciones: data[0].observaciones,
          //fabricante_id: "",
          //establecimiento_id: "",
          //titular_id: "",
          propiedades_inmunologicas: data[0].propiedades_inmunologicas,
          validez_preparacion: data[0].validez_preparacion,
          instrucciones_uso: data[0].instrucciones_uso, //
          clasificacion_id: data[0].clasificacion_id, //
          clasificacion: clasificacion,
        });
      }
    });

    Api.fetch("app/getRegentesProducto?id=" + this.state.id).then((data) => {
      if (data) {
        this.setState({ regentes: data.regentes });
      }
    });

    Api.fetch("app/getRepresentantesLegalesProducto?id=" + this.state.id).then(
      (data) => {
        if (data) {
          this.setState({ representantes_legales: data.representantes });
        }
      }
    );

    //Despues le asignamos el fabricante anteriormente ingresado //FALTA PROBAR
    Api.fetch("app/getFabricanteProducto?id=" + this.state.id).then((data) => {
      if (data) {
        this.setState({
          fabricantes: data.lista_fabricantes,
          fabricante_id: data.fabricante.id,
        });
      }
    });

    Api.fetch("app/getTitularProducto?id=" + this.state.id).then((data) => {
      if (data) {
        this.setState({
          titulares: data.lista_titulares,
          titular_id: data.titular.id,
        });
      }
    });

    if (tipo_producto_id === "1" || tipo_producto_id === "2") {
      Api.fetch("cat/getIngredienteTipoMedicamento").then((data) => {
        if (data) {
          this.setState({
            options_ingredientes_activos: data.activos,
            options_ingredientes_excipientes: data.excipiente,
          });
        }
      });
      //buscamos el ingrediente activo y exipiente del producto
      Api.fetch("app/getIngredienteTipoMedProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            //this.state.principio_activo.principio_activo_id

            this.setState({
              principios_activos: data.activos,
              excipientes: data.excipiente,
            });
          }
        }
      );
    }

    if (tipo_producto_id === "3" || tipo_producto_id === "4") {
      Api.fetch("cat/getIngredienteTipoAlimento").then((data) => {
        if (data) {
          this.setState({ options_ingredientes: data.alimento });
        }
      });
    }

    Api.fetch("cat/getEspecieCategoria").then((data) => {
      if (data) {
        this.setState({ options_categoria: data.categorias });
      }
    });

    if (tipo_producto_id === "1" || tipo_producto_id === "2") {
      Api.fetch("app/getFormaFarmaceutica").then((data) => {
        if (data) {
          this.setState({
            options_forma_farmaceutica: data.tipo_1,
            options_forma_farmaceutica_tipo_1: data.tipo_1,
            options_forma_farmaceutica_tipo_2: data.tipo_2,
            options_forma_farmaceutica_tipo_3: data.tipo_3,
          });
        }
      });

      Api.fetch("cat/getEmpaqueTipoProducto").then((data) => {
        if (data) {
          this.setState({
            options_empaque: data.tipo_1,
            options_empaque_tipo_1: data.tipo_1,
            options_empaque_tipo_2: data.tipo_2,
            options_empaque_tipo_3: data.tipo_3,
          });
        }
      });

      //buscamos los empaques del producto
      Api.fetch("app/getEmpaqueProducto?id=" + this.state.id).then((data) => {
        if (data) {
          this.setState({ empaques: data });
        }
      });

      //biologicos
      //buscamos COMPOSICION BIOLOGICA del producto
      Api.fetch("app/getComposicionBiologicaProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({ composiciones_biologicas: data });
          }
        }
      );

      //buscamos COMPOSICION QUIMICA del producto
      Api.fetch("app/getComposicionQuimicaProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({ composiciones_quimicas: data });
          }
        }
      );

      //modo de empleo
      Api.fetch("app/getModoDeEmpleoProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({ modos_empleo: data });
          }
        }
      );

      //componente (reactivo)
      Api.fetch("app/getComponenteProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({
              componentes: data,
            });
          }
        }
      );
      //especie interes (reactivo)
      Api.fetch("app/getEspecieInteresProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({
              especies_interes_diagnostico: data,
            });
          }
        }
      );
      //presentacion (reactivo)
      Api.fetch("app/getPresentacionProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({
              presentaciones: data,
            });
          }
        }
      );
    } else if (tipo_producto_id === "3" || tipo_producto_id === "4") {
      Api.fetch("app/getFormaFarmaceutica").then((data) => {
        if (data) {
          this.setState({
            options_forma_farmaceutica: data.tipo_5,
          });
        }
      });

      Api.fetch("cat/getEmpaqueTipoProductoAlimento").then((data) => {
        if (data) {
          this.setState({
            options_empaque: data.empaque_tipo_alimento,
          });
        }
      });

      Api.fetch("app/getEmpaqueProducto?id=" + this.state.id).then((data) => {
        if (data) {
          this.setState({ empaques: data });
        }
      });

      //analisis
      Api.fetch("app/getAnalisisProducto?id=" + this.state.id).then((data) => {
        if (data) {
          this.setState({
            analisis: data,
          });
        }
      });
      //ingredientes
      Api.fetch("app/getIngredientesProducto?id=" + this.state.id).then(
        (data) => {
          if (data) {
            this.setState({
              ingredientes: data,
            });
          }
        }
      );
    }

    //dosis medicamento vet biologico y // alimento
    //buscamos las dosis especie del producto
    Api.fetch("app/getDosisEspecieProducto?id=" + this.state.id).then(
      (data) => {
        if (data) {
          this.setState({ dosis: data });
        }
      }
    );

    //descarte medicamento vet y biologico // alimento
    //buscamos periodo de descarte del producto
    Api.fetch("app/getPeriodoDescarteProducto?id=" + this.state.id).then(
      (data) => {
        if (data) {
          this.setState({ descartes: data });
        }
      }
    );

    /* Validar principio activo y excipiente */
    Api.fetch("app/getControlIngredientes").then((r) => {
      Api.loading(0);
      this.setState({ control_ingredientes: r });

      let liveWatch = setInterval(
        // Tip timer
        (x) => {
          if (
            window.location.toString().split("/")[4] !== "inscripcion-producto"
          ) {
            clearInterval(liveWatch);
          }

          let opt = document.querySelectorAll("#categoria_id > option");
          for (let i = 0; i < opt.length; i++) {
            opt[i].removeAttribute("disabled");
          }

          if (document.querySelector("#categoria_id") !== null) {
            document.querySelector("#categoria_id").removeAttribute("disabled");
          }

          for (let pa in this.state.principios_activos) {
            this.state.control_ingredientes.find((e, indexe) => {
              let dosis = [...this.state.dosis];
              dosis.find((o, indexo) => {
                if (o) {
                  if (
                    e.especie === o.especie_name &&
                    e.categoria === o.categoria_name
                  ) {
                    if (e.estado === "Prohibido") {
                      dosis.splice(indexo, 1);
                      this.setState({ dosis: dosis });
                    }
                  }
                }
              });

              if (
                e.nombre ===
                this.state.principios_activos[pa].principio_activo_name
              ) {
                opt = document.querySelector(
                  "#categoria_id > option[data-categoria='" + e.categoria + "']"
                );
                if (opt) {
                  opt.setAttribute("disabled", 1);
                }
              }
            });
          }

          for (let ex in this.state.excipientes) {
            this.state.control_ingredientes.find((e, indexe) => {
              let dosis = [...this.state.dosis];
              dosis.find((o, indexo) => {
                if (o) {
                  if (
                    e.especie === o.especie_name &&
                    e.categoria === o.categoria_name
                  ) {
                    if (e.estado === "Prohibido") {
                      dosis.splice(indexo, 1);
                      this.setState({ dosis: dosis });
                    }
                  }
                }
              });

              if (
                e.nombre === this.state.excipientes[ex].principio_activo_name
              ) {
                opt = document.querySelector(
                  "#categoria_id > option[data-categoria='" + e.categoria + "']"
                );
                if (opt) {
                  opt.setAttribute("disabled", 1);
                }
              }
            });
          }
        },
        500
      );
    });
    //FIN VALIDAR PROHIBIDOS Y CONTROLADOS

    //Traemos la informacion de cada uno de los selects
  }

  handleReset = (e) => {
    window.location.href = "/productos/listado";
  };

  handleOpcionesRadio(e) {
    //dependiendo de el valor del tipo cambian ciertas listas y el valor de de tipo_producto_veterinario
    let opt_empaque = [];
    let opt_forma_farmaceutica = [];
    let tpv;

    opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_5;
    switch (e.target.value) {
      case "medicamento_veterinario":
        opt_empaque = this.state.options_empaque_tipo_1;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_1;
        tpv = "1";
        break;
      case "biologico":
        opt_empaque = this.state.options_empaque_tipo_2;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_2;
        tpv = "2";
        break;
      case "producto_afin":
        opt_empaque = this.state.options_empaque_tipo_3;
        opt_forma_farmaceutica = this.state.options_forma_farmaceutica_tipo_3;
        tpv = "3";
        break;
      case "reactivos_diagnosticos":
        tpv = "4";
        break;
      default:
    }
    this.setState({
      tipo: e.target.value,
      tipo_producto_veterinario_id: tpv,
      options_empaque: opt_empaque,
      options_forma_farmaceutica: opt_forma_farmaceutica,
    });
  }

  /* PRINCIPIO ACTIVO */

  handlePrincipioActivo(e) {
    let tipo_control = e.target[e.target.selectedIndex];

    let swalType = {
      Normal: "",
      Prohibido: "error",
      Controlado: "warning",
    };

    let esp = "";
    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        this.state.control_ingredientes.find((o) => {
          if (o.nombre === tipo_control.innerText) {
            if (!o.categoria) {
              e.target.value = "";
              esp += "<li><b>" + o.especie + "</b></li>";
              return;
            } else {
              esp += "<li><b>" + o.especie + "</b> " + o.categoria + "</li>";
            }
          }
        });

        Swal.fire(
          "Atención " + tipo_control.innerText,
          "Principio activo " +
            tipo_control.dataset.tipo +
            " en <hr /> <o style='text-align:left'>" +
            esp +
            "</o>",
          swalType[tipo_control.dataset.tipo]
        );
      }
    }

    let rep = { ...this.state.principio_activo }; //hacemos una copia del objeto

    if (e.target.name === "principio_activo_id" && e.target.value !== "") {
      let principio_activo_name = this.state.options_ingredientes_activos.find(
        (d) => d.id === e.target.value
      );
      if (principio_activo_name) {
        rep["principio_activo_name"] = principio_activo_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    this.setState({ principio_activo: rep });
  }

  addPrincipioActivo(e) {
    let rep = { ...this.state.principio_activo };
    let pa = [...this.state.principios_activos];

    if (
      rep.principio_activo_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in this.state.principios_activos) {
        if (pa[re].principio_activo_id === rep.principio_activo_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);

      this.setState({
        principios_activos: pa,
        principio_activo: this.initialState.principio_activo,
      });
    }
  }

  removePrincipioActivo(e) {
    let principio_activos = [...this.state.principios_activos];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (principio_activos[e.target.id]["rel_id"] !== "") {
      eliminados["principios_activos"].push(
        principio_activos[e.target.id]["rel_id"]
      );
    }

    principio_activos.splice(e.target.id, 1);
    this.setState({
      principios_activos: principio_activos,
      rel_eliminados: eliminados,
    });
  }

  /* EXCIPIENTE */

  handleExcipiente(e) {
    let tipo_control = e.target[e.target.selectedIndex];

    let swalType = {
      Normal: "",
      Prohibido: "error",
      Controlado: "warning",
    };

    let esp = "";
    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        this.state.control_ingredientes.find((o) => {
          if (o.nombre === tipo_control.innerText) {
            if (!o.categoria) {
              e.target.value = "";
              esp += "<li><b>" + o.especie + "</b></li>";
              return;
            } else {
              esp += "<li><b>" + o.especie + "</b> " + o.categoria + "</li>";
            }
          }
        });

        Swal.fire(
          "Atención " + tipo_control.innerText,
          "Principio activo " +
            tipo_control.dataset.tipo +
            " en <hr /> <o style='text-align:left'>" +
            esp +
            "</o>",
          swalType[tipo_control.dataset.tipo]
        );
      }
    }

    let rep = { ...this.state.excipiente }; //hacemos una copia del objeto

    if (e.target.name === "excipiente_id" && e.target.value !== "") {
      let excipiente_name = this.state.options_ingredientes_excipientes.find(
        (d) => d.id === e.target.value
      );
      if (excipiente_name) {
        rep["excipiente_name"] = excipiente_name.nombre;
      }
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    this.setState({ excipiente: rep });
  }

  addExcipiente(e) {
    let rep = { ...this.state.excipiente };
    let pa = [...this.state.excipientes];

    if (
      rep.excipiente_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in this.state.excipientes) {
        if (pa[re].excipiente_id === rep.excipiente_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);

      this.setState({
        excipientes: pa,
        excipiente: this.initialState.excipiente,
      });
    }
  }

  removeExcipiente(e) {
    let excipientes = [...this.state.excipientes];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (excipientes[e.target.id]["rel_id"] !== "") {
      eliminados["excipientes"].push(excipientes[e.target.id]["rel_id"]);
    }
    excipientes.splice(e.target.id, 1);
    this.setState({ excipientes: excipientes, rel_eliminados: eliminados });
  }

  /* DOSIS */

  handleDosisEspecie(e) {
    let rep = { ...this.state.dosis_especie };

    if (e.target.name === "especie_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      if (especie_name) {
        rep["especie_name"] = especie_name.descripcion;
      }
      let categorias = this.state.options_categoria.find(
        (d) => d.especie_id === e.target.value
      );

      if (categorias !== undefined) {
        rep["tiene_categoria"] = true;
      } else {
        rep["tiene_categoria"] = false;
      }
    } else if (e.target.name === "categoria_id" && e.target.value !== "") {
      let categoria_name = this.state.options_categoria.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      if (categoria_name) {
        rep["categoria_name"] = categoria_name.descripcion;
      }
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ dosis_especie: rep });
  }

  addDosisEspecie(e) {
    let rep = { ...this.state.dosis_especie };
    let pa = [...this.state.dosis];

    if (
      (rep.dosis !== "" &&
        rep.especie_id !== "" &&
        rep.categoria_id !== "" &&
        rep.tiene_categoria === true) ||
      (rep.dosis !== "" &&
        rep.especie_id !== "" &&
        rep.tiene_categoria === false)
    ) {
      /*  for (let re in this.state.dosis) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie en su lista.",
          });
          return false;
        }
      } */
      pa.push(rep);
      this.setState({
        dosis: pa,
        dosis_especie: this.initialState.dosis_especie,
      });
    }
  }

  removeDosisEspecie(e) {
    let dosis = [...this.state.dosis];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (dosis[e.target.id]["rel_id"] !== "") {
      eliminados["dosis"].push(dosis[e.target.id]["rel_id"]);
    }
    dosis.splice(e.target.id, 1);
    this.setState({ dosis: dosis, rel_eliminados: eliminados });
  }

  /* EMPAQUE */

  handleEmpaque(e) {
    let rep = { ...this.state.empaque };
    if (e.target.name === "empaque_id" && e.target.value !== "") {
      let empaque_name = this.state.options_empaque.find(
        (d) => d.id === e.target.value
      );
      rep["empaque_name"] = empaque_name.descripcion;
    } else if (
      e.target.name === "presentacion_unidad_medida" &&
      e.target.value !== ""
    ) {
      let presentacion_unidad_medida = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["presentacion_unidad_medida_name"] =
        presentacion_unidad_medida.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ empaque: rep });
  }

  addEmpaque(e) {
    let rep = { ...this.state.empaque };

    let pa = [...this.state.empaques];

    if (
      rep.empaque_id !== "" &&
      rep.presentacion_cantidad !== "" &&
      rep.presentacion_unidad_medida !== ""
    ) {
      /*for (let re in this.state.empaques) {
        if (pa[re].empaque_id === rep.empaque_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este empaque en su lista.",
          });
          return false;
        } */
      pa.push(rep);
      this.setState({ empaques: pa, empaque: this.initialState.empaque });
    }
  }

  removeEmpaque(e) {
    let empaques = [...this.state.empaques];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (empaques[e.target.id]["rel_id"] !== "") {
      eliminados["empaques"].push(empaques[e.target.id]["rel_id"]);
    }
    empaques.splice(e.target.id, 1);
    this.setState({ empaques: empaques, rel_eliminados: eliminados });
  }

  /* DESCARTE */

  handleDescarte(e) {
    let rep = { ...this.state.descarte };

    if (e.target.name === "medida_tiempo_id" && e.target.value !== "") {
      let medida_tiempo_name = this.state.options_medida_tiempo.find(
        (d) => d.id === e.target.value
      );
      rep["medida_tiempo_name"] = medida_tiempo_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else if (e.target.name === "especie_prod_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies_producto.find(
        (d) => d.id === e.target.value
      );
      rep["especie_prod_name"] = especie_name.descripcion;
      rep[e.target.name] = e.target.value;
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ descarte: rep });
  }

  addDescarte(e) {
    let rep = { ...this.state.descarte };
    let pa = [...this.state.descartes];

    if (
      rep.periodo !== "" &&
      rep.medida_tiempo_id &&
      rep.especie_prod_id !== ""
    ) {
      for (let re in pa) {
        if (pa[re].especie_prod_id === rep.especie_prod_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este producto en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({ descartes: pa, descarte: this.initialState.descarte });
    }
  }

  removeDescarte(e) {
    let descartes = [...this.state.descartes];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (descartes[e.target.id]["rel_id"] !== "") {
      eliminados["descartes"].push(descartes[e.target.id]["rel_id"]);
    }
    descartes.splice(e.target.id, 1);
    this.setState({ descartes: descartes, rel_eliminados: eliminados });
  }

  /* COMPOSICION BIOLOGICA */
  handleComposicionBiologica(e) {
    let rep = { ...this.state.composicion_biologica };
    if (e.target.name === "composicion_biologica_id" && e.target.value !== "") {
      let composicion_biologica_name =
        this.state.options_composicion_biologica.find(
          (d) => d.id === e.target.value
        );
      rep["composicion_biologica_name"] =
        composicion_biologica_name.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ composicion_biologica: rep });
  }

  addComposicionBio(e) {
    let rep = { ...this.state.composicion_biologica };
    let pa = [...this.state.composiciones_biologicas];

    if (
      rep.composicion_biologica_id !== "" &&
      rep.titulo_unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].composicion_biologica_id === rep.composicion_biologica_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta composición biológica en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({
        composiciones_biologicas: pa,
        composicion_biologica: this.initialState.composicion_biologica,
      });
    }
  }

  removeComposicionBio(e) {
    let composiciones_biologicas = [...this.state.composiciones_biologicas];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (composiciones_biologicas[e.target.id]["rel_id"] !== "") {
      eliminados["composiciones_biologicas"].push(
        composiciones_biologicas[e.target.id]["rel_id"]
      );
    }
    composiciones_biologicas.splice(e.target.id, 1);
    this.setState({
      composiciones_biologicas: composiciones_biologicas,
      rel_eliminados: eliminados,
    });
  }

  /* COMPOSICION QUIMICA*/

  handleComposicionQuimica(e) {
    let rep = { ...this.state.composicion_quimica };
    if (e.target.name === "composicion_quimica_id" && e.target.value !== "") {
      let composicion_quimica_name =
        this.state.options_composicion_quimica.find(
          (d) => d.id === e.target.value
        );
      rep["composicion_quimica_name"] = composicion_quimica_name.descripcion;
    }

    if (e.target.name === "unidad_medida" && e.target.value !== "") {
      let unidad_medida_name = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["unidad_medida_name"] = unidad_medida_name.descripcion;
    }

    rep[e.target.name] = e.target.value;
    this.setState({ composicion_quimica: rep });
  }

  addComposicionQuimica(e) {
    let rep = { ...this.state.composicion_quimica };
    let pa = [...this.state.composiciones_quimicas];

    if (
      rep.composicion_quimica_id !== "" &&
      rep.concentracion !== "" &&
      rep.unidad_medida !== ""
    ) {
      for (let re in pa) {
        if (pa[re].composicion_quimica_id === rep.composicion_quimica_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta composición química en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({
        composiciones_quimicas: pa,
        composicion_quimica: this.initialState.composicion_quimica,
      });
    }
  }

  removeComposicionQuimica(e) {
    let composiciones_quimicas = [...this.state.composiciones_quimicas];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (composiciones_quimicas[e.target.id]["rel_id"] !== "") {
      eliminados["composiciones_quimicas"].push(
        composiciones_quimicas[e.target.id]["rel_id"]
      );
    }
    composiciones_quimicas.splice(e.target.id, 1);
    this.setState({
      composiciones_quimicas: composiciones_quimicas,
      rel_eliminados: eliminados,
    });
  }

  /* COMPONENTE */

  handleComponente(e) {
    let rep = { ...this.state.componente };
    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ componente: rep });
  }

  addComponente(e) {
    let rep = { ...this.state.componente };
    let pa = [...this.state.componentes];

    if (rep.componente !== "" && rep.concentracion !== "") {
      pa.push(rep);
      this.setState({
        componentes: pa,
        componente: this.initialState.componente,
      });
    }
  }

  removeComponente(e) {
    let componentes = [...this.state.componentes];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (componentes[e.target.id]["rel_id"] !== "") {
      eliminados["componentes"].push(componentes[e.target.id]["rel_id"]);
    }
    componentes.splice(e.target.id, 1);
    this.setState({ componentes: componentes, rel_eliminados: eliminados });
  }

  /* ESPECIE DE INTERES */

  handleEspecieInteres(e) {
    let rep = { ...this.state.especie_interes_diagnostico };
    let especie_name = this.state.options_especies.find(
      (d) => d.id === e.target.value
    );
    rep[e.target.name] = e.target.value;
    rep["especie_name"] = especie_name.descripcion;

    this.setState({ especie_interes_diagnostico: rep });
  }

  addEspecieInteres(e) {
    let rep = { ...this.state.especie_interes_diagnostico };
    let pa = [...this.state.especies_interes_diagnostico];

    if (rep.especie_id !== "") {
      for (let re in pa) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie de interés en su lista.",
          });
          return false;
        }
      }
      pa.push(rep);
      this.setState({
        especies_interes_diagnostico: pa,
        especie_interes_diagnostico:
          this.initialState.especie_interes_diagnostico,
      });
    }
  }

  removeEspecieInteres(e) {
    let especies_interes_diagnostico = [
      ...this.state.especies_interes_diagnostico,
    ];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (especies_interes_diagnostico[e.target.id]["rel_id"] !== "") {
      eliminados["especies_interes_diagnostico"].push(
        especies_interes_diagnostico[e.target.id]["rel_id"]
      );
    }
    especies_interes_diagnostico.splice(e.target.id, 1);
    this.setState({
      especies_interes_diagnostico: especies_interes_diagnostico,
      rel_eliminados: eliminados,
    });
  }

  /* MODO DE EMPLEO */

  handleModoEmpleo(e) {
    let rep = { ...this.state.modo_empleo };

    if (e.target.name === "especie_id" && e.target.value !== "") {
      let especie_name = this.state.options_especies.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      rep["especie_name"] = especie_name.descripcion;
      let categorias = this.state.options_categoria.find(
        (d) => d.especie_id === e.target.value
      );

      if (categorias !== undefined) {
        rep["tiene_categoria"] = true;
      } else {
        rep["tiene_categoria"] = false;
      }
    } else if (e.target.name === "categoria_id" && e.target.value !== "") {
      let categoria_name = this.state.options_categoria.find(
        (d) => d.id === e.target.value
      );
      rep[e.target.name] = e.target.value;
      rep["categoria_name"] = categoria_name.descripcion;
    } else {
      rep[e.target.name] = e.target.value.toUpperCase();
    }

    this.setState({ modo_empleo: rep });
  }

  addModoEmpleo(e) {
    let rep = { ...this.state.modo_empleo };
    let pa = [...this.state.modos_empleo];

    if (
      (rep.modo_empleo !== "" &&
        rep.especie_id !== "" &&
        rep.categoria_id !== "" &&
        rep.tiene_categoria === true) ||
      (rep.modo_empleo !== "" &&
        rep.especie_id !== "" &&
        rep.tiene_categoria === false)
    ) {
      /*for (let re in this.state.modos_empleo) {
        if (pa[re].especie_id === rep.especie_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta especie en su lista.",
          });
          return false;
        } */
      pa.push(rep);
      this.setState({
        modos_empleo: pa,
        modo_empleo: this.initialState.modo_empleo,
      });
    }
  }

  removeModoEmpleo(e) {
    let modos_empleo = [...this.state.modos_empleo];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (modos_empleo[e.target.id]["rel_id"] !== "") {
      eliminados["modos_empleo"].push(modos_empleo[e.target.id]["rel_id"]);
    }
    modos_empleo.splice(e.target.id, 1);
    this.setState({ modos_empleo: modos_empleo, rel_eliminados: eliminados });
  }

  /* PRESENTACIONES */

  handlePresentaciones(e) {
    let rep = { ...this.state.presentacion };
    if (
      e.target.name === "presentacion_unidad_medida" &&
      e.target.value !== ""
    ) {
      let presentacion_unidad_medida = this.state.options_unidad_medida.find(
        (d) => d.id === e.target.value
      );
      rep["presentacion_unidad_medida_name"] =
        presentacion_unidad_medida.descripcion;
    }

    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ presentacion: rep });
  }

  addPresentaciones(e) {
    let rep = { ...this.state.presentacion };
    let pa = this.state.presentaciones;

    if (
      rep.presentacion_cantidad !== "" &&
      rep.presentacion_unidad_medida !== ""
    ) {
      pa.push(rep);
      this.setState({
        presentaciones: pa,
        presentacion: this.initialState.presentacion,
      });
    }
  }

  removePresentaciones(e) {
    let presentaciones = [...this.state.presentaciones];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (presentaciones[e.target.id]["rel_id"] !== "") {
      eliminados["presentaciones"].push(presentaciones[e.target.id]["rel_id"]);
    }
    presentaciones.splice(e.target.id, 1);
    this.setState({
      presentaciones: presentaciones,
      rel_eliminados: eliminados,
    });
  }

  /* ANALISIS GARANTIZADO */

  handleAnalisis(e) {
    let rep = { ...this.state.analisis_garantizado };
    if (e.target.name === "analisis_id" && e.target.value !== "") {
      let analisis_name = this.state.options_analisis.find(
        (d) => d.id === e.target.value
      );
      rep["analisis_name"] = analisis_name.descripcion;
    }
    rep[e.target.name] = e.target.value;
    this.setState({ analisis_garantizado: rep });
  }

  addAnalisis(e) {
    let rep = { ...this.state.analisis_garantizado };
    let pa = [...this.state.analisis];

    if (rep.analisis_id !== "") {
      for (let re in pa) {
        if (pa[re].analisis_id === rep.analisis_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este análisis en su lista.",
          });
          return false;
        }
      }
      pa.push(rep);
      this.setState({
        analisis: pa,
        analisis_garantizado: this.initialState.analisis_garantizado,
      });
    }
  }

  removeAnalisis(e) {
    let analisis = [...this.state.analisis];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (analisis[e.target.id]["rel_id"] !== "") {
      eliminados["analisis"].push(analisis[e.target.id]["rel_id"]);
    }
    analisis.splice(e.target.id, 1);
    this.setState({
      analisis: analisis,
      rel_eliminados: eliminados,
    });
  }

  /* INGREDIENTES */

  handleIngrediente(e) {
    let tipo_control = e.target[e.target.selectedIndex];

    let swalType = {
      Normal: "",
      Prohibido: "error",
      Controlado: "warning",
    };

    if (tipo_control !== undefined) {
      if (tipo_control.dataset.tipo) {
        Swal.fire(
          "Atención " + tipo_control.innerText,
          "Principio activo " + tipo_control.dataset.tipo,
          swalType[tipo_control.dataset.tipo]
        );

        if (tipo_control.dataset.tipo !== "Controlado") {
          e.target.value = "";
        }
      }
    }

    let rep = { ...this.state.ingrediente };
    let ingrediente_name = this.state.options_ingredientes.find(
      (d) => d.id === e.target.value
    );
    if (ingrediente_name) {
      rep["ingrediente_name"] = ingrediente_name.nombre;
    }
    rep[e.target.name] = e.target.value;
    this.setState({ ingrediente: rep });
  }

  addIngrediente(e) {
    let rep = { ...this.state.ingrediente };
    let pa = [...this.state.ingredientes];

    if (rep.ingrediente_id !== "") {
      for (let re in pa) {
        if (pa[re].ingrediente_id === rep.ingrediente_id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con este ingrediente en su lista.",
          });
          return false;
        }
      }

      pa.push(rep);
      this.setState({
        ingredientes: pa,
        ingrediente: this.initialState.ingrediente,
      });
    }
  }

  removeIngrediente(e) {
    let ingredientes = [...this.state.ingredientes];
    let eliminados = { ...this.state.rel_eliminados };
    //checamos si el elemento a eliminar tiene rel_id y lo agregamos a la lista de rel_id eliminados
    if (ingredientes[e.target.id]["rel_id"] !== "") {
      eliminados["ingredientes"].push(ingredientes[e.target.id]["rel_id"]);
    }
    ingredientes.splice(e.target.id, 1);
    this.setState({
      ingredientes: ingredientes,
      rel_eliminados: eliminados,
    });
  }

  handleClasificacion(e) {
    let clasificacion = { ...this.clasificacion };
    clasificacion[e.target.name] = e.target.value;
    this.setState({ clasificacion: clasificacion });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ procesando: true });

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };
    // shallow copy is inherit of the main state
    delete postData.options_unidad_medida;
    delete postData.options_ingredientes_activos;
    delete postData.options_ingredientes_excipientes;
    delete postData.options_especies;
    delete postData.options_categoria;
    delete postData.options_empaque;
    delete postData.options_medida_tiempo;
    delete postData.options_forma_farmaceutica;
    delete postData.options_paises;

    let tipo_vet = this.state.tipo_producto_veterinario_id;
    let tipo_producto = this.state.tipo_producto_id;

    if (tipo_producto === "3" || tipo_producto === "4") {
      tipo_vet = "5";
    }

    if (
      this.state.principios_activos.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "3")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un principio activo.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.excipientes.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "3")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un excipiente.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.composiciones_biologicas.length === 0 &&
      tipo_vet === "2"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una composición biológica.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.composiciones_quimicas.length === 0 &&
      tipo_vet === "2"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una composición química.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.analisis.length === 0 && tipo_vet === "5") {
      Swal.fire({
        title: "Es necesario agregar al menos un análisis garantizado.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.ingredientes.length === 0 && tipo_vet === "5") {
      Swal.fire({
        title: "Es necesario agregar al menos un ingrediente.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (
      this.state.empaques.length === 0 &&
      (tipo_vet === "1" || tipo_vet === "2" || tipo_vet === "5")
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos un envase/empaque.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.componentes.length === 0 && tipo_vet === "4") {
      Swal.fire({
        title: "Es necesario agregar al menos un componente.",
        icon: "error",
      });
    } else if (
      this.state.especies_interes_diagnostico.length === 0 &&
      tipo_vet === "4"
    ) {
      Swal.fire({
        title: "Es necesario agregar al menos una especie de interés.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.presentaciones.length === 0 && tipo_vet === "4") {
      Swal.fire({
        title: "Es necesario agregar al menos una presentación.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.fabricante_id === "") {
      Swal.fire({
        title: "Es necesario seleccionar un fabricante.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.valor_anterior === "") {
      Swal.fire({
        title: "Es necesario ingresar valor anterior.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else if (this.state.valor_nuevo === "") {
      Swal.fire({
        title: "Es necesario ingresar valor nuevo.",
        icon: "error",
      });
      this.setState({ procesando: false });
    } else {
      /*         //una vez que tienes poblado el formulario este es el codigo de guardar
        //con esto manda una copia del estado al controlador como un json  en data
        let data =JSON.parse(JSON.stringify(postData));
        //con esto manda una copia del estado al controlador como un json  en data
        Api.fetch("app/saveProductosSnap",{data:data}, "POST").then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            this.setState({ procesando: false });
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text:
                "Revise la información e intente de nuevo su última acción.", //message,
            });
          }); //catching errors to show notification
        }); */

      Api.fetch("app/productEdit", postData, "POST")
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            this.setState({ procesando: false });
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: "Revise la información e intente de nuevo su última acción.", //message,
            });
          }); //catching errors to show notification
        });
    }
  }

  handleRegister(e) {
    if (e.errors) {
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .toUpperCase()}</li>`;
      }
      tplErrors += `</u>`;
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      this.setState({ procesando: false });
      return false;
    } else {
      Swal.fire({
        title: "Información Almacenada",
        icon: "success",
        text: "La información de la anotación marginal ha sido actualizada exitosamente.",
      }).then(() => {
        window.location = "/solicitudes/drycip";
      });
    }
    this.setState({ procesando: false });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    const tipo_producto = this.state.tipo_producto_id;
    let Titulo, tipo_forma;
    if (tipo_producto === "1" || tipo_producto === "2") {
      Titulo = "Editar producto para medicamentos veterinarios";
      tipo_forma = "Forma farmacéutica";
    } else if (tipo_producto === "3" || tipo_producto === "4") {
      Titulo = "Editar producto para alimentación animal";
      tipo_forma = "Forma de comercialización";
    }

    return (
      <div>
        {/*   <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/form/elements">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/form/elements">Productos</Link>
          </li>
          <li className="breadcrumb-item active">
            {Titulo}
          </li>
        </ol> */}

        <h1 className="page-header">{Titulo}</h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form style={{ margin: "3%" }} onSubmit={this.handleSubmit}>
                  <div className="row">
                    <fieldset className={"form-group col-md-12"}>
                      <legend>
                        Anotación Marginal {this.state.anotacion_marginal}
                      </legend>
                      Petición:
                      <input
                        type="text"
                        name="peticion"
                        value={this.state.peticion}
                        disabled={true}
                        className="form-control m-b-5"
                        //required
                      />
                    </fieldset>

                    <div
                      className={
                        this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2"
                          ? "form-group col-md-12"
                          : "form-group col-md-6"
                      }
                    >
                      <label>Nombre comercial: </label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="nombre_comercial"
                        value={this.state.nombre_comercial}
                        //disabled={this.state.disabled}
                        autoComplete="off"
                        onChange={(e) =>
                          this.setState({
                            nombre_comercial: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4"
                          ? "form-group col-md-6"
                          : "hide"
                      }
                    >
                      <label>Clasificación: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="clasificacion_id"
                        className="form-control m-b-5"
                        value={this.state.clasificacion_id}
                        onChange={(e) =>
                          this.setState({
                            clasificacion_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_clasificacion.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className={"row hide"}>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="medicamento_veterinario"
                        checked={this.state.tipo === "medicamento_veterinario"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "medicamento_veterinario" })}
                      />
                      Medicamento Veterinario
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="biologico"
                        checked={this.state.tipo === "biologico"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "biologico" })}
                      />
                      Biológico
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="producto_afin"
                        checked={this.state.tipo === "producto_afin"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "producto_afin" })}
                      />
                      Producto Afín
                    </div>
                    <div className="col-md-3 m-b-15">
                      <input
                        type="radio"
                        value="reactivos_diagnosticos"
                        checked={this.state.tipo === "reactivos_diagnosticos"}
                        onChange={this.handleOpcionesRadio}
                        //onChange={(e) => this.setState({ tipo: "reactivos_diagnosticos" })}
                      />
                      Reactivos de diagnósticos
                    </div>
                  </div>

                  {/* PRINCIPIO ACTIVO */}
                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="principio_activo"
                  >
                    <div className="form-group col-md-5">
                      Principio activo: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          name="principio_activo_id"
                          className="form-control m-b-5 "
                          onChange={this.handlePrincipioActivo}
                          value={
                            this.state.principio_activo.principio_activo_id
                          }
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_ingredientes_activos.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                                data-tipo={option.descripcion}
                              >
                                {option.nombre}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        name="concentracion"
                        type="number"
                        onChange={this.handlePrincipioActivo}
                        value={this.state.principio_activo.concentracion}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handlePrincipioActivo}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.principio_activo.unidad_medida}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addPrincipioActivo}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista principios activos */}

                  <div
                    className={
                      this.state.principios_activos.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaPrincipiosActivos" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Principio activo</th>
                            <th>Concentración</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.principios_activos.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.principio_activo_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removePrincipioActivo}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removePrincipioActivo}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* EXCIPIENTE */}

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="excipiente"
                  >
                    <div className="form-group col-md-5">
                      Excipiente: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleExcipiente}
                          name="excipiente_id"
                          className="form-control m-b-5 "
                          value={this.state.excipiente.excipiente_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_ingredientes_excipientes.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                                data-tipo={option.descripcion}
                              >
                                {option.nombre}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        name="concentracion"
                        type="number"
                        value={this.state.excipiente.concentracion}
                        onChange={this.handleExcipiente}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div
                        className="row" /* style={{marginRight:"0.09em"}}  */
                      >
                        <select
                          onChange={this.handleExcipiente}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.excipiente.unidad_medida}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addExcipiente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista excipientes */}

                  <div
                    className={
                      this.state.excipientes.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos" &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaExcipientes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Excipiente</th>
                            <th>Concentración</th>
                            <th>Unidad medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.excipientes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.excipiente_name}</td>
                              <td>{reg.concentracion}</td>
                              <td>{reg.unidad_medida_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeExcipiente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeExcipiente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPOSICION BIOLOGICA */}

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="composicion_biologica"
                  >
                    <div className="form-group col-md-5">
                      Composición biológica
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleComposicionBiologica}
                          name="composicion_biologica_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.composicion_biologica
                              .composicion_biologica_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_composicion_biologica.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Titulo/Unidad de medida:{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="titulo_unidad_medida"
                        value={
                          this.state.composicion_biologica.titulo_unidad_medida
                        }
                        onChange={this.handleComposicionBiologica}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>
                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComposicionBio}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista composicion biologica */}

                  <div
                    className={
                      this.state.composiciones_biologicas.length > 0 &&
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComposicionBiologica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición biológica</th>
                            <th>Titulo/Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.composiciones_biologicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_biologica_name}</td>
                                <td>{reg.titulo_unidad_medida}</td>
                                <td>
                                  <button
                                    type="button"
                                    id={index}
                                    onClick={this.removeComposicionBio}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeComposicionBio}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPOSICION QUIMICA */}

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="composicion_quimica"
                  >
                    <div className="form-group col-md-5">
                      Composición química:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleComposicionQuimica}
                          name="composicion_quimica_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.composicion_quimica
                              .composicion_quimica_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_composicion_quimica.map(
                            (option) => (
                              <option
                                className="dropdown-item"
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-3">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        type="number"
                        name="concentracion"
                        value={this.state.composicion_quimica.concentracion}
                        onChange={this.handleComposicionQuimica}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div
                        className="row" /* style={{marginRight:"0.09em"}}  */
                      >
                        <select
                          onChange={this.handleComposicionQuimica}
                          name="unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.composicion_quimica.unidad_medida}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComposicionQuimica}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista composicion quimica */}

                  <div
                    className={
                      this.state.composiciones_quimicas.length > 0 &&
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComposicionQuimica" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Composición química</th>
                            <th>Concentración</th>
                            <th>Unidad medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.composiciones_quimicas.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.composicion_quimica_name}</td>
                                <td>{reg.concentracion}</td>
                                <td>{reg.unidad_medida_name}</td>
                                <td>
                                  <button
                                    type="button"
                                    id={index}
                                    onClick={this.removeComposicionQuimica}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeComposicionQuimica}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ANALISIS GARANTIZADO */}

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4"
                        ? "row"
                        : "row hide"
                    }
                    id="analisis"
                  >
                    <div className="form-group col-md-5">
                      Análisis garantizado:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          name="analisis_id"
                          value={this.state.analisis_garantizado.analisis_id}
                          onChange={this.handleAnalisis}
                          className="form-control m-b-5"
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_analisis.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Porcentaje(%): <span className="text-danger">*</span>
                      <input
                        type="number"
                        name="porcentaje"
                        value={this.state.analisis_garantizado.porcentaje}
                        onChange={this.handleAnalisis}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addAnalisis}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista ANALISIS GARANTIZADO */}

                  <div
                    className={
                      this.state.analisis.length > 0 &&
                      (this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4")
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaAnalisis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Análisis garantizado</th>
                            <th>Porcentaje(%)</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.analisis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.analisis_name}</td>
                              <td>{reg.porcentaje}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeAnalisis}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeAnalisis}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* INGREDIENTE */}

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4"
                        ? "row"
                        : "row hide"
                    }
                    id="ingredientes"
                  >
                    <div className="form-group col-md-11">
                      Ingrediente: <span className="text-danger">*</span>
                      <select
                        name="ingrediente_id"
                        value={this.state.ingrediente.ingrediente_id}
                        onChange={this.handleIngrediente}
                        className="form-control m-b-5"
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_ingredientes.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                            data-tipo={option.descripcion}
                          >
                            {option.nombre}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addIngrediente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista ingredientes */}

                  <div
                    className={
                      this.state.ingredientes.length > 0 &&
                      (this.state.tipo_producto_id === "3" ||
                        this.state.tipo_producto_id === "4")
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaIngredientes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Ingrediente</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.ingredientes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.ingrediente_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeIngrediente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeIngrediente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DOSIS POR ESPECIE */}

                  <div
                    className={
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="dosis_especies_via"
                  >
                    <div className="form-group col-md-5">
                      Dosis por especie y vía de administración:
                      <input
                        type="input"
                        name="dosis"
                        onChange={this.handleDosisEspecie}
                        value={this.state.dosis_especie.dosis}
                        className="form-control m-b-5"
                        //style={{width:"36.3em",resize: "horizontal"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.dosis_especie.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-6"
                      }
                    >
                      Especie destino:
                      <div className="row" style={{ marginLeft: "0.08em" }}>
                        <select
                          onChange={this.handleDosisEspecie}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={this.state.dosis_especie.especie_id}
                          /* style={{ width: "20.5em" }} */
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_especies.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.dosis_especie.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-3 hide"
                      }
                    >
                      Categoría:
                      <div className="row">
                        <select
                          onChange={this.handleDosisEspecie}
                          name="categoria_id"
                          id="categoria_id"
                          className="form-control m-b-5"
                          value={this.state.dosis_especie.categoria_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_categoria
                            .filter(
                              (e) =>
                                e.especie_id ===
                                this.state.dosis_especie.especie_id
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                data-categoria={option.descripcion}
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addDosisEspecie}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista dosis */}

                  <div
                    className={
                      this.state.dosis.length > 0 &&
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDosis" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Dosis</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.dosis.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.dosis}</td>
                              <td>{reg.especie_name}</td>
                              <td>{reg.categoria_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeDosisEspecie}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeDosisEspecie}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* MODO DE EMPLEO POR ESPECIE */}

                  <div
                    className={
                      this.state.tipo === "producto_afin" ? "row" : "row hide"
                    }
                    id="modo_empleo"
                  >
                    <div className="form-group col-md-5">
                      Modo de empleo: <span className="text-danger"></span>
                      <input
                        type="input"
                        name="modo_empleo"
                        onChange={this.handleModoEmpleo}
                        value={this.state.modo_empleo.modo_empleo}
                        className="form-control m-b-5"
                        //style={{width:"36.3em",resize: "horizontal"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div
                      className={
                        this.state.modo_empleo.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-6"
                      }
                    >
                      Especie destino: <span className="text-danger"></span>
                      <div className="row" style={{ marginLeft: "0.08em" }}>
                        <select
                          onChange={this.handleModoEmpleo}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={this.state.modo_empleo.especie_id}

                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_especies.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.modo_empleo.tiene_categoria
                          ? "form-group col-md-3"
                          : "form-group col-md-3 hide"
                      }
                    >
                      Categoría: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handleModoEmpleo}
                          name="categoria_id"
                          className="form-control m-b-5 "
                          value={this.state.modo_empleo.categoria_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_categoria
                            .filter(
                              (e) =>
                                e.especie_id ===
                                this.state.modo_empleo.especie_id
                            )
                            .map((option) => (
                              <option
                                className="dropdown-item"
                                //data-nombre=
                                key={option.id}
                                value={option.id}
                              >
                                {option.descripcion}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addModoEmpleo}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista modo de empleo */}

                  <div
                    className={
                      this.state.modos_empleo.length > 0 &&
                      this.state.tipo === "producto_afin"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaModoEmpleo" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Modo de empleo</th>
                            <th>Especie</th>
                            <th>Categoría</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.modos_empleo.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.modo_empleo}</td>
                              <td>{reg.especie_name}</td>
                              <td>{reg.categoria_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeModoEmpleo}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeModoEmpleo}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* TIPO DE ENVASE */}

                  <div
                    className={
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="envases"
                  >
                    <div className="form-group col-md-5">
                      Tipo de envase/empaque:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleEmpaque}
                          name="empaque_id"
                          className="form-control m-b-5 "
                          value={this.state.empaque.empaque_id}
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_empaque.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/*  <div className="form-group col-md-4">
                     Presentaciones: <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="presentacion"
                        value={this.state.empaque.presentacion}
                        onChange={this.handleEmpaque}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      /> 
                      </div> */}

                    <div className="form-group col-md-3">
                      Presentaciones cantidad:{" "}
                      <span className="text-danger">*</span>
                      <input
                        name="presentacion_cantidad"
                        type="number"
                        onChange={this.handleEmpaque}
                        value={this.state.empaque.presentacion_cantidad}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-3">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handleEmpaque}
                          name="presentacion_unidad_medida"
                          className="form-control m-b-5 "
                          value={this.state.empaque.presentacion_unidad_medida}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addEmpaque}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista empaques */}

                  <div
                    className={
                      this.state.empaques.length > 0 &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaEmpaques" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Empaque</th>
                            {/*  <th>Presentaciones</th> */}
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.empaques.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.empaque_name}</td>
                              {/* <td>{reg.presentacion}</td> */}
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeEmpaque}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeEmpaque}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DESCARTE */}

                  <div
                    className={
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="periodo_descarte"
                  >
                    <div className="form-group col-md-3">
                      Periodo de retiro o descarte:{" "}
                      <span className="text-danger"></span>
                      <input
                        type="number"
                        name="periodo"
                        value={this.state.descarte.periodo}
                        onChange={this.handleDescarte}
                        className="form-control m-b-5"
                        //style={{width:"36.3em"}}
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-2">
                      Tiempo: <span className="text-danger"></span>
                      <select
                        name="medida_tiempo_id"
                        className="form-control m-b-5 "
                        value={this.state.descarte.medida_tiempo_id}
                        onChange={this.handleDescarte}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_medida_tiempo
                          .filter(
                            (e) =>
                              e.descripcion === "Días" ||
                              e.descripcion === "Horas"
                          )
                          .map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      Especie producto: <span className="text-danger"></span>
                      <select
                        onChange={this.handleDescarte}
                        name="especie_prod_id"
                        className="form-control  "
                        value={this.state.descarte.especie_prod_id}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_especies_producto.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addDescarte}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista descarte */}

                  <div
                    className={
                      this.state.descartes.length > 0 &&
                      this.state.tipo !== "producto_afin" &&
                      this.state.tipo !== "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaDescartes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Periodo</th>
                            <th>Tiempo</th>
                            <th>Especie producto</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.descartes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.periodo}</td>
                              <td>{reg.medida_tiempo_name}</td>
                              <td>{reg.especie_prod_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeDescarte}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeDescarte}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* COMPONENTES */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="componentes"
                  >
                    <div className="form-group col-md-5">
                      Componente: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="input"
                          name="componente"
                          value={this.state.componente.componente}
                          onChange={this.handleComponente}
                          className="form-control m-b-5"
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Concentración: <span className="text-danger">*</span>
                      <input
                        type="input"
                        name="concentracion"
                        value={this.state.componente.concentracion}
                        onChange={this.handleComponente}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addComponente}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista componentes */}

                  <div
                    className={
                      this.state.componentes.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaComponentes" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Componente</th>
                            <th>Concentración</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.componentes.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.componente}</td>
                              <td>{reg.concentracion}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removeComponente}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeComponente}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ESPECIE INTERES DIAGNOSTICO */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="especie_interes_diagnostico"
                  >
                    <div className="form-group col-md-11">
                      Especie de interés diagnóstico:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <select
                          onChange={this.handleEspecieInteres}
                          name="especie_id"
                          className="form-control m-b-5 "
                          value={
                            this.state.especie_interes_diagnostico.especie_id
                          }
                          //disabled={this.state.esBaja}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_especies.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addEspecieInteres}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista especie interes diagnostico */}

                  <div
                    className={
                      this.state.especies_interes_diagnostico.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div
                      id="listaEspecieInteresDiagnostico"
                      className="col-md-12"
                    >
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Especie</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.especies_interes_diagnostico.map(
                            (reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.especie_name}</td>
                                <td>
                                  <button
                                    type="button"
                                    id={index}
                                    onClick={this.removeEspecieInteres}
                                    className="btn btn-warning pull-right"
                                  >
                                    <i
                                      id={index}
                                      onClick={this.removeEspecieInteres}
                                      className="fas fa-trash"
                                    ></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* PRESENTACIONES */}

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="presentaciones"
                  >
                    {/* <div className="form-group col-md-11">
                      Presentaciones: <span className="text-danger">*</span>
                       <input
                        type="input"
                        name="presentacion"
                        value={this.state.presentacion.presentacion}
                        onChange={this.handlePresentaciones}
                        className="form-control m-b-5"
                        placeholder=""
                      /> 
                    </div>  */}

                    <div className="form-group col-md-5">
                      Presentaciones cantidad:{" "}
                      <span className="text-danger">*</span>
                      <input
                        name="presentacion_cantidad"
                        type="input"
                        onChange={this.handlePresentaciones}
                        value={this.state.presentacion.presentacion_cantidad}
                        className="form-control m-b-5"
                        placeholder=""
                        //required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      Unidad de medida: <span className="text-danger">*</span>
                      <div className="row">
                        <select
                          onChange={this.handlePresentaciones}
                          name="presentacion_unidad_medida"
                          className="form-control m-b-5 "
                          value={
                            this.state.presentacion.presentacion_unidad_medida
                          }
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.options_unidad_medida.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-1" style={{ marginTop: "1.5em" }}>
                      <button
                        type="button"
                        className="btn btn-info col-md-12"
                        onClick={this.addPresentaciones}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  {/* Lista presentaciones */}

                  <div
                    className={
                      this.state.presentaciones.length > 0 &&
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                  >
                    <div id="listaPresentaciones" className="col-md-12">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Presentaciones cantidad</th>
                            <th>Unidad de medida</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.presentaciones.map((reg, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{reg.presentacion_cantidad}</td>
                              <td>{reg.presentacion_unidad_medida_name}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  onClick={this.removePresentaciones}
                                  className="btn btn-warning pull-right"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removePresentaciones}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* DETALLES PRODUCTO */}

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo !== "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="precauciones_generales"
                  >
                    <div className="form-group col-md-12">
                      <label>Precauciones generales:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_generales"
                        value={this.state.precauciones_generales}
                        onChange={(e) =>
                          this.setState({
                            precauciones_generales:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo_producto_id === "3" ||
                      this.state.tipo_producto_id === "4" ||
                      this.state.tipo === "biologico"
                        ? "row"
                        : "row hide"
                    }
                    id="precauciones_biologico"
                  >
                    <div className="form-group col-md-6">
                      <label>Precauciones de uso:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_uso"
                        value={this.state.precauciones_uso}
                        onChange={(e) =>
                          this.setState({
                            precauciones_uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Precauciones de almacenamiento:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="precauciones_almacenamiento"
                        value={this.state.precauciones_almacenamiento}
                        onChange={(e) =>
                          this.setState({
                            precauciones_almacenamiento:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-7">
                      Caducidad del producto:{" "}
                      <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="number"
                          name="caducidad_producto"
                          value={this.state.caducidad_producto}
                          onChange={(e) =>
                            this.setState({
                              caducidad_producto: e.target.value.toUpperCase(),
                            })
                          }
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-5">
                      Tiempo: <span className="text-danger">*</span>
                      <select
                        name="tiempo"
                        className="form-control m-b-5 "
                        value={this.state.medida_tiempo_id}
                        onChange={(e) =>
                          this.setState({
                            medida_tiempo_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_medida_tiempo.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Forma farmaceutica */}

                  <div className="row">
                    <div
                      className={
                        this.state.tipo !== "reactivos_diagnosticos"
                          ? "form-group col-md-6"
                          : "form-group col-md-6 hide"
                      }
                      id="forma_farmaceutica"
                    >
                      <label>{tipo_forma} </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="forma_farmaceutica_id"
                        className="form-control m-b-5"
                        value={this.state.forma_farmaceutica_id}
                        onChange={(e) =>
                          this.setState({
                            forma_farmaceutica_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_forma_farmaceutica.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={
                        this.state.tipo !== "reactivos_diagnosticos"
                          ? "form-group col-md-6"
                          : "form-group col-md-12"
                      }
                    >
                      <label>País de origen:</label>
                      <span className="text-danger"> *</span>

                      <select
                        name="pais_origen_id"
                        className="form-control m-b-5"
                        value={this.state.pais_origen_id}
                        onChange={(e) =>
                          this.setState({
                            pais_origen_id: e.target.value,
                          })
                        }
                        disabled={this.state.tipo_producto_id === "1" || this.state.tipo_producto_id === "3"? true : false } //si es nacional
                        required
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_paises.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo !== "biologico" ? "row" : "row hide"
                    }
                    id="indicaciones_uso"
                  >
                    <div className="form-group col-md-12">
                      <label>Indicaciones de uso: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="uso"
                        value={this.state.uso}
                        onChange={(e) =>
                          this.setState({
                            uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo === "reactivos_diagnosticos"
                        ? "row"
                        : "row hide"
                    }
                    id="instrucciones_uso"
                  >
                    <div className="form-group col-md-12">
                      <label>Instrucciones de uso: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="instrucciones_uso"
                        value={this.state.instrucciones_uso}
                        onChange={(e) =>
                          this.setState({
                            instrucciones_uso: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      (this.state.tipo_producto_id === "1" ||
                        this.state.tipo_producto_id === "2") &&
                      this.state.tipo === "medicamento_veterinario"
                        ? "row"
                        : "row hide"
                    }
                    id="validez_preparacion"
                  >
                    <div className="form-group col-md-12">
                      <label>Validez para preparación extemporánea: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="validez_preparacion"
                        value={this.state.validez_preparacion}
                        onChange={(e) =>
                          this.setState({
                            validez_preparacion: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div
                    className={
                      this.state.tipo === "biologico" ? "row" : "row hide"
                    }
                    id="propiedades_inmunologicas"
                  >
                    <div className="form-group col-md-12">
                      <label>Propiedades inmunológicas: </label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="propiedades_inmunologicas"
                        value={this.state.propiedades_inmunologicas}
                        onChange={(e) =>
                          this.setState({
                            propiedades_inmunologicas:
                              e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Fabricante: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="fabricante_id"
                        className="form-control m-b-5"
                        value={this.state.fabricante_id}
                        onChange={(e) =>
                          this.setState({
                            fabricante_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.fabricantes.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/*                     <div className="form-group col-md-6">
                      <label>Titular: </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="titular_id"
                        className="form-control m-b-5"
                        value={this.state.titular_id}
                        onChange={(e) =>
                          this.setState({
                            titular_id: e.target.value,
                          })
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.titulares.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.razon_social}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>

                  {/* REPRESENTANTES LEGALES */}

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Representante legal: </label>
                      <span className="text-danger"> *</span>
                      <div
                        id="listaRepresentantes"
                        className={
                          this.state.representantes_legales.length > 0
                            ? ""
                            : "hide"
                        }
                      >
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.representantes_legales.map(
                              (reg, index) => (
                                <tr key={index} id={"t" + index}>
                                  <td>{reg.nombre}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* REGENTES */}

                    <div className="form-group col-md-6">
                      <label>Regentes: </label>
                      <span className="text-danger"> *</span>
                      <div
                        id="listaRegentes"
                        className={this.state.regentes.length > 0 ? "" : "hide"}
                      >
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Nombre completo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.regentes.map((reg, index) => (
                              <tr key={index} id={"t" + index}>
                                <td>{reg.nombre}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <hr />

                  {/* CLASIFICACION */}

                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Grupo de riesgo </label>
                      <span className="text-danger"> *</span>
                      <select
                        name="grupo_ingrediente_id"
                        className="form-control m-b-5"
                        value={this.state.clasificacion.grupo_ingrediente_id}
                        onChange={this.handleClasificacion}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_grupo_ingredientes.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className={
                        this.state.tipo_producto_veterinario_id <= 3
                          ? "form-group col-md-6"
                          : "hide"
                      }
                    >
                      <label>Clasificación del producto :</label>
                      <span className="text-danger"> *</span>

                      <select
                        name="pais_origen_id"
                        className="form-control m-b-5"
                        value={this.state.clasificacion.clase_producto_id}
                        onChange={this.handleClasificacion}
                        required
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_clasificacion_producto.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div
                      className={
                        this.state.tipo_producto_veterinario_id <= 3
                          ? "form-group col-md-6"
                          : "form-group col-md-12"
                      }
                    >
                      <label>Categoría de venta :</label>
                      <span className="text-danger"> *</span>

                      <select
                        name="pais_origen_id"
                        className="form-control m-b-5"
                        value={
                          this.state.clasificacion.categorizacion_oficial_id
                        }
                        onChange={this.handleClasificacion}
                        required
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_categorizacion_oficial.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      Tomo: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="text"
                          name="tomo"
                          value={this.state.clasificacion.tomo}
                          onChange={this.handleClasificacion}
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Folio: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="text"
                          name="folio"
                          value={this.state.clasificacion.folio}
                          onChange={this.handleClasificacion}
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-md-6">
                      Número de registro: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="text"
                          name="no_registro_drycip"
                          value={this.state.clasificacion.no_registro_drycip}
                          onChange={this.handleClasificacion}
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      Dossier: <span className="text-danger">*</span>
                      <div className="row" style={{ marginLeft: "0.09em" }}>
                        <input
                          type="text"
                          name="dossier"
                          value={this.state.clasificacion.dossier}
                          onChange={this.handleClasificacion}
                          className="form-control m-b-5 "
                          placeholder=""
                          //required
                        />
                      </div>
                    </div>
                  </div>

                  <hr></hr>
                  {/* VALOR ANTERIOR Y NUEVO PRODUCTO */}

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label>Valor anterior:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="valor_anterior"
                        value={this.state.valor_anterior}
                        onChange={(e) =>
                          this.setState({
                            valor_anterior: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Valor nuevo:</label>
                      <span className="text-danger"> *</span>

                      <TextareaAutosize //aria-label="minimum height"
                        rowsMin={3}
                        rowsMax={3}
                        name="valor_nuevo"
                        value={this.state.valor_nuevo}
                        onChange={(e) =>
                          this.setState({
                            valor_nuevo: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <hr></hr>

                  <div
                    className={
                      this.state.procesando
                        ? "progress rounded-corner m-b-15"
                        : "hide"
                    }
                  >
                    <div
                      className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <h4>Cargando, espere...</h4>
                    </div>
                  </div>

                  <div
                    className={this.state.procesando ? "hide" : "pull-right"}
                  >
                    <div style={{ marginBottom: "10%" }}>
                      <button
                        type="button"
                        onClick={this.handleReset}
                        className="btn btn-danger m-r-5"
                      >
                        Regresar
                      </button>
                      <button
                        type="button"
                        onClick={this.handleSubmit}
                        className=" btn btn-success m-r-5"
                      >
                        Generar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  const match = useRouteMatch();
  return <Product auth={auth} history={history} match={match} {...props} />;
};
